import type { VariantProps } from 'class-variance-authority'
import { badgeVariants } from '@/components/ui/badge'

type BadgeVariant = NonNullable<VariantProps<typeof badgeVariants>['variant']>

// Mapa status do processo → variante semântica do Badge. Segue a regra do DS:
// success = publicado/pronto, warning = em andamento com o agente, critical =
// falha/bloqueio, info = rascunho/estados neutros.
const PROCESS_STATUS_VARIANT: Record<string, BadgeVariant> = {
  draft: 'info',
  with_agent: 'warning',
  procedure_documenting: 'warning',
  procedure_ready: 'info',
  skill_generating: 'warning',
  skill_generated: 'info',
  published: 'success',
  publication_failed: 'critical',
  blocked: 'critical',
  archived: 'secondary',
}

export function processStatusVariant(status: string): BadgeVariant {
  return PROCESS_STATUS_VARIANT[status] ?? 'info'
}
